// extracted by mini-css-extract-plugin
module.exports = {"link-tags-container":"subcategories-section_link-tags-container__K7kTj","link-tag":"subcategories-section_link-tag__G4_Ik"};